module.exports = __webpack_public_path__ + "static/img/articlefoot_icon_logo.70c0ea5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/articlefoot_icon_logo.png
// module id = OTlR
// module chunks = 0